import { FilteredCreditApplication, PageSectionTitle as SectionTitle, UnderReviewTile } from '@applyonline/shared'
import { ECreditApplicationStep } from '@if/core/types'
import { useTranslation } from 'react-i18next'
import UploadFilesTable from '../../../../components/UploadFilesTable'
import { hasMissingDocuments } from '../../../../data/creditapp-selectors'

interface Props {
  creditApp: FilteredCreditApplication
}
const RequiredDocForDecisionForm = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const hasMissingDocs = hasMissingDocuments(creditApp, ECreditApplicationStep.Credit)
  return hasMissingDocs ? (
    <main className="general-message">
      {hasMissingDocs && (
        <div>
          <SectionTitle title={t('common.financeApplication')} />
          <h1>{t('decision.creditDocumentRequiredTitle')}</h1>
          <div className="paragraph">
            <p>{t('decision.creditDocumentRequired')}</p>
            <p>{t('identity.notifyEmail')}</p>
          </div>
          <UploadFilesTable creditApp={creditApp} />
        </div>
      )}
    </main>
  ) : (
    <UnderReviewTile />
  )
}

export default RequiredDocForDecisionForm
